import { Component, DoCheck, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BehaviorSubject,Observable } from 'rxjs';
import { Multi } from '../../../interfaces/multi.interface';
import { LineChartOptions } from '../../GraphQL/LineChart/linechart.component';
import { EveReportingWidgetDataSource } from '../widget-menu-settings/widget-datasource/widget-datasource.component';
import { EveReportingWidget } from '../widget.component';

import { IDataSourceService, iDataSource } from '../../../services/DataSourceServices/IDataSourceService.service';



@Component({
  selector: 'line-chart-widget',
  templateUrl: 'line-chart-widget.component.html',
  styleUrls: ['./line-chart-widget.component.css']
})
export class LineChartWidgetComponent implements OnInit, DoCheck {

  options: LineChartOptions;  
  
  @Input()
  widget?: EveReportingLineChartWidget = null;

  @Output()
  isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  hasErrored: EventEmitter<boolean> = new EventEmitter<boolean>(); 

  widgetObservables: BehaviorSubject<EveReportingWidget>;

  results: Observable<Multi[]>;
  
  constructor(
    public dataSourceService: IDataSourceService
  )
  {
  }

  ngOnInit(): void {
    this.isLoading.emit(false);
    this.hasErrored.emit(false);

    this.options = {
      width: null,
      height: null,
      chartHeader: null,
      xAxisLabel: this.widget?.xAxisLabel,
      yAxisLabel: this.widget?.yAxisLabel,
      colourScheme: this.widget?.colourScheme

      
    }

    //service import
    this.widgetObservables = new BehaviorSubject<EveReportingWidget>(JSON.parse(JSON.stringify(this.widget)));
    this.results = this.dataSourceService.MultiResults(this.widgetObservables, staticResults);

  }

  ngDoCheck(): void {

    if (this.options.xAxisLabel != this.widget?.xAxisLabel) this.options.xAxisLabel = this.widget?.xAxisLabel;
    if (this.options.yAxisLabel != this.widget?.yAxisLabel) this.options.yAxisLabel = this.widget?.yAxisLabel;
    if (this.options.colourScheme != this.widget?.colourScheme) this.options.colourScheme = this.widget?.colourScheme;

    if (JSON.stringify(this.widget) !== JSON.stringify(this.widgetObservables.value)) this.widgetObservables.next(JSON.parse(JSON.stringify(this.widget)));
  }

  public onSelect(data) {
    //this.select.emit(data);
    alert("hi");
  }


}



export interface EveReportingLineChartWidget extends EveReportingWidget, iDataSource {
  xAxisLabel: string,
  yAxisLabel: string,
  colourScheme: any,

  dataSource: EveReportingWidgetDataSource
}



const staticResults: Multi[] = [
  {
    name: "User1",
    series: [
      {
        //name: "01/12/2022",
        name: new Date(2022, 12, 1),
        value: 10
      },
      {
        name: new Date(2022, 12, 2),
        value: 5
      },
      {
        name: new Date(2022, 12, 3),
        value: 25
      }
    ]
  },
  {
    name: "User2",
    series: [
      {
        name: new Date(2022, 12, 1),
        value: 12
      },
      {
        name: new Date(2022, 12, 2),
        value: 9
      },
      {
        name: new Date(2022, 12, 3),
        value: 17
      }
    ]
  },
  {
    name: "User3",
    series: [
      {
        name: new Date(2022, 12, 1),
        value: 23
      },
      {
        name: new Date(2022, 12, 2),
        value: 11
      },
      {
        name: new Date(2022, 12, 3),
        value: 6
      }
    ]
  }
];
